module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box__footer"
  }, [_c('div', {
    staticClass: "box__title"
  }, [_c('user-tag', {
    attrs: {
      "user": _vm.user
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box__content"
  }, [_c('div', {
    staticClass: "box__image"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d5ee601","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/video/components/user_box.vue
// module id = 1669
// module chunks = 180